<template>
	<div>
		<div class="float-compare" v-if="showButton">
			<button class="btn dynvibeButtonCompare" @click="showModal()">Profiles graph</button>
		</div>
		<div v-if="showCompare">
			<nav class="sidebar-compare">
				<div class="row">
					<div class="col-xs-1 text-right">
						<div class="dismiss-compare" @click="showCompare = false">
							<span aria-hidden="true">
								<i class="icon-x"></i>
							</span>
						</div>
					</div>
				</div>
				<div class="dynvibeBox">
					<div class="col-lg-12">
						<ul class="nav nav-tabs" role="tablist">
							<li class="nav-item active">
								<a
									class="nav-link"
									data-toggle="tab"
									href="#"
									role="tab"
									v-bind:class="{ active: selectedTab === 'profilesAll' }"
									@click="selectedTab = 'profilesAll'"
									>All Profiles</a
								>
							</li>
							<li class="nav-item">
								<a
									class="nav-link"
									data-toggle="tab"
									href="#"
									role="tab"
									v-bind:class="{ active: selectedTab === 'profilesFemale' }"
									@click="selectedTab = 'profilesFemale'"
									>Female</a
								>
							</li>
							<li class="nav-item">
								<a
									class="nav-link"
									data-toggle="tab"
									href="#"
									role="tab"
									v-bind:class="{ active: selectedTab === 'profilesMale' }"
									@click="selectedTab = 'profilesMale'"
									>Male</a
								>
							</li>
						</ul>
						<div class="tabs-content">
							<listprofilecircles
								class="tab-pane"
								:ref="selectedTab"
								axios="profilesSlider"
								v-bind="$props"
								:gender="selectedTab.slice(8)"
							></listprofilecircles>
						</div>
					</div>
				</div>

				<div class="row dynvibeRow">
					<div class="col-lg-12">
						<div class="dynvibeBox">
							<div class="col-lg-4 col-xs-12">
								<div class="col-lg-12 dynvibeTitleBox">
									<h2>Gender</h2>
								</div>
								<dynvibepie ref="genderProfiles" axios="genderProfiles" :clickable="false"></dynvibepie>
							</div>
							<div class="col-lg-4 col-xs-12">
								<div class="col-lg-12 dynvibeTitleBox">
									<h2>Age groups</h2>
								</div>
								<dynvibepie ref="ageProfiles" axios="ageProfiles" title="Age groups" :clickable="false"></dynvibepie>
							</div>
							<div class="col-lg-4 col-xs-12">
								<div class="col-lg-12 dynvibeTitleBox">
									<h2>By gender</h2>
								</div>
								<dynvibebaropposite
									ref="genderAgeProfiles"
									axios="genderAgeProfiles"
									title="By gender"
									:clickable="false"
								></dynvibebaropposite>
							</div>
						</div>
					</div>
				</div>
			</nav>
		</div>
	</div>
</template>

<script>
import listprofilecircles from "@/components/globalVue/ListProfileCircles.vue";
import dynvibepie from "@/components/vueCharts/DynvibePie.vue";
import dynvibebaropposite from "@/components/vueCharts/DynvibeBarOpposite.vue";

export default {
	name: "profilesgraph",
	props: {
		search: {
			type: String,
			default: "",
		},
		panel: {
			type: String,
			default: "",
		},
		segment: {
			type: String,
			default: "",
		},
		impact_score_min: {
			type: String,
			default: "",
		},
		impact_score_max: {
			type: String,
			default: "",
		},
		is_checked: {
			type: Array,
			default: () => [],
		},
		no_segment: {
			type: Boolean,
			default: false,
		},
		checkbox_all: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			showCompare: false,
			showCategory: true,
			showSubCategory: true,
			showButton: true,
			selectedTab: "profilesAll",
		};
	},
	components: {
		listprofilecircles: listprofilecircles,
		dynvibepie: dynvibepie,
		dynvibebaropposite: dynvibebaropposite,
	},
	methods: {
		loadComponent() {},
		showModal() {
			this.showCompare = true;
		},
	},
	watch: {
		showCompare: function () {
			if (this.showCompare == false) {
				this.selectedTab = "profilesAll";
			}
		},
	},
};
</script>

<style>
.float-compare {
	position: fixed;
	top: 82px; /* 67px if style scoped */
	right: 50px;
	z-index: 2;
}

.dynvibeButtonCompare {
	font-family: "Montserrat";
	height: 26px;
	outline: 0;
	border: 1px solid #33d1cd;
	color: #33d1cd;
	background-color: #fff;
	text-transform: uppercase;
	padding: 2px 10px;
	transition: none !important;
	cursor: pointer;
	border-top-left-radius: 20px;
	border-bottom-left-radius: 20px;
}

.dynvibeButtonCompare:focus,
.dynvibeButtonCompare:active,
.dynvibeButtonCompare:hover {
	outline: none !important;
	box-shadow: none;
	color: #fff;
	background-color: #33d1cd;
}

.graphComparison {
	display: flex;
	justify-content: center;
	margin-left: 0 !important;
	width: 100%;
}

.sidebar-compare {
	width: calc(100vw - 120px);
	position: fixed;
	top: 81px;
	/*right: -90vw;*/
	right: 0;
	height: 100vh;
	z-index: 999;
	transition: all 0.3s;
	overflow-y: scroll;
	background-color: #fff;
	border: 1px solid rgb(229, 229, 229);
	padding: 15px;
	margin-bottom: 100px;
}

.sidebar-compare div.row:first-child {
	margin-bottom: 50px;
}

.sidebar-compare div.row:last-child {
	margin-bottom: 100px;
}

.sidebar-compare-open {
	right: 0 !important;
	background: white;
	box-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
}

.dismiss-compare {
	width: 35px;
	height: 35px;
	position: absolute;
	float: left;
	top: 15px;
	left: 20px;
	cursor: pointer;
}
</style>
